import slugify from './slugify';


const isItemActive = (location, item, sectionId) => {
    const source = location.pathname.slice(0, location.pathname.length - 1);
    const pageId = "/" + source.split('/').slice(source.split('/').length - 2).join("/") + "/";

    return pageId === slugify(item.id, sectionId);
};

export default isItemActive;
